class CartCount extends HTMLElement {
  constructor() {
    super();

    const increment = (event) => {
      const cart = event.detail;
      if (cart && typeof cart.item_count === "number") {
        this.textContent = cart.item_count;
        return;
      }

      const current = Number(this.textContent) || 0;
      this.textContent = current + 1;
    };

    document.addEventListener("addtocart", increment);
    document.addEventListener("cartupsell", increment);

    document.addEventListener("cart:change", (event) => {
      const cart = event.detail;
      if (!cart || typeof cart.item_count !== "number") return;

      this.textContent = cart.item_count;
    });
  }
}

customElements.define("component-cart-count", CartCount);
